import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolavasacitycab() {



const cardData =
{
  keyword: 'Pune to Lavasa City Cabs',
  heading: 'Lotus Cab: Pune to Lavasa City Cabs',

  headingDescription: 'Lotus Cab offers premium Pune to Lavasa City Cabs designed for travelers seeking a scenic, comfortable, and relaxing getaway from Pune. Lavasa, known for its Italian-inspired waterfront architecture and serene lakeside beauty, is one of the most popular weekend destinations near Pune. The route to Lavasa includes beautiful ghat roads, winding hill curves, and panoramic valley views, which require skilled driving and safe vehicles. Our Pune to Lavasa taxi service ensures timely pickup from your doorstep, smooth highway travel, and comfortable arrival at your resort or lakeside location. Whether you are planning a romantic weekend, corporate offsite, family vacation, photography trip, or adventure outing, we provide flexible one-way and round-trip travel options. Our fleet includes clean AC sedans and spacious SUVs suitable for hill driving. Transparent pricing, no hidden charges, experienced drivers, and 24/7 booking support make Lotus Cab the preferred choice for Pune to Lavasa travel. Enjoy a stress-free, scenic road journey with professional service and complete travel comfort.',

  top: 'Top Places to Visit in Lavasa with Lotus Cab',

  "topPlaces": [
    {
      "title": "Lakeside Promenade",
      "description": "The Lakeside Promenade is the heart of Lavasa City, offering beautiful waterfront views, colorful European-style buildings, and peaceful walking paths. Visitors enjoy boating, lakeside cafes, and sunset photography here. Lotus Cab ensures comfortable drop directly at the promenade area for relaxed exploration."
    },
    {
      "title": "Temghar Dam",
      "description": "Temghar Dam offers breathtaking panoramic views of surrounding hills and water reservoir. It is perfect for nature photography and peaceful sightseeing during monsoon season."
    },
    {
      "title": "Dasve View Point",
      "description": "A popular scenic point providing stunning hilltop views of Lavasa’s landscape and valleys. Ideal for sunrise and sunset photography."
    },
    {
      "title": "Bamboosa",
      "description": "A unique bamboo craft store showcasing eco-friendly handmade products and local creativity."
    },
    {
      "title": "Water Sports Activities",
      "description": "Visitors can enjoy jet skiing, kayaking, pedal boating, and other water activities along Lavasa Lake."
    },
    {
      "title": "Tikona Fort",
      "description": "A short drive from Lavasa, this historic fort offers trekking opportunities and panoramic Sahyadri views."
    },
    {
      "title": "Tamhini Ghat",
      "description": "One of the most scenic monsoon drives near Lavasa, famous for waterfalls and lush greenery."
    },
    {
      "title": "Mulshi Lake",
      "description": "A peaceful lakeside destination ideal for photography and relaxation."
    },
    {
      "title": "Lavasa Nature Trails",
      "description": "Well-maintained walking trails for nature lovers and fitness enthusiasts."
    },
    {
      "title": "Lakeshore Restaurants",
      "description": "Lavasa offers lakeside dining experiences with beautiful sunset views and multi-cuisine options."
    }
  ],

  "services": [
    {
      "name": "Pune to Lavasa Cabs",
      "description": "Lotus Cab provides highly reliable Pune to Lavasa Cabs ensuring smooth and safe hill travel for families, couples, and corporate groups. The scenic ghat road to Lavasa requires experienced drivers who are familiar with sharp curves and elevation changes. Our professional chauffeurs are trained for hill driving and ensure passenger safety throughout the journey. Vehicles are fully air-conditioned, sanitized before every trip, and maintained for long-distance comfort. We provide punctual pickup from any area in Pune including airport, railway station, IT parks, and residential societies. Whether you are planning a weekend getaway, romantic trip, family outing, or corporate offsite, our flexible travel plans allow one-way and round-trip booking. Transparent pricing structure with clear per kilometer rates ensures no billing confusion. Our customer support team assists you throughout booking and trip coordination. With comfortable seating, ample luggage space, and safe driving, Lotus Cab makes your Lavasa journey peaceful and memorable."
    },
    {
      "name": "Pune to Lavasa Taxi Service",
      "description": "Our Pune to Lavasa Taxi Service is designed for comfortable and scenic hill travel with experienced drivers who understand the terrain and safety protocols of ghat sections. Vehicles are regularly serviced and equipped with proper braking systems for hill driving. Customers can choose between sedan and SUV options depending on group size. Transparent fare structure and timely pickup ensure hassle-free travel experience. We coordinate return timing based on your sightseeing plan to give you complete flexibility."
    },
    {
      "name": "Pune to Lavasa One Way Cab",
      "description": "Affordable one-way cab option for travelers who want drop-only service to Lavasa without return charges. Ideal for resort stays, relocation visits, and extended holidays. Transparent billing ensures you only pay for the actual drop distance."
    },
    {
      "name": "Pune to Lavasa Round Trip Taxi",
      "description": "Flexible round-trip travel service allowing you to enjoy full sightseeing and return safely at your chosen time. Drivers wait as per scheduled hours and ensure comfortable return drive."
    },
    {
      "name": "Affordable Pune to Lavasa Cab",
      "description": "Budget-friendly Lavasa cab packages with competitive per km pricing, no hidden charges, and reliable vehicle quality for comfortable travel."
    },
    {
      "name": "Luxury Cab Pune to Lavasa",
      "description": "Premium sedan and SUV vehicles offering superior comfort, plush seating, smooth suspension, and executive travel experience for couples and VIP travelers."
    },
    {
      "name": "SUV Taxi Pune to Lavasa",
      "description": "Spacious SUV taxis ideal for family and group travel to Lavasa with extra luggage space and enhanced hill-road stability."
    },
    {
      "name": "Pune to Lavasa Family Trip Cab",
      "description": "Specially designed family cab packages with comfortable seating, child-friendly travel support, and flexible sightseeing schedule for relaxed holiday experience."
    }
  ],

  "tableData": [
    ["Pune to Lavasa Cabs", "Pune to Lavasa Taxi Service"],
    ["Pune to Lavasa One Way Cab", "Pune to Lavasa Round Trip Taxi"],
    ["Pune to Lavasa Weekend Trip Cab", "Affordable Pune to Lavasa Cab"],
    ["Luxury Cab Pune to Lavasa", "SUV Taxi Pune to Lavasa"],
    ["Cheap Pune to Lavasa Taxi", "Online Cab Booking Pune to Lavasa"],
    ["Best Pune to Lavasa Cab Service", "Pune to Lavasa Family Trip Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Hill Drivers",
      "WhyChoosedescription": "Our drivers are trained for safe hill-road driving and understand ghat safety protocols ensuring smooth and secure travel."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear per km billing with no hidden charges, ensuring complete cost transparency."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained and sanitized vehicles suitable for long-distance and hill travel comfort."
    },
    {
      "WhyChooseheading": "Flexible One Way & Round Trip",
      "WhyChoosedescription": "Choose travel plan according to your holiday schedule."
    },
    {
      "WhyChooseheading": "On-Time Pickup",
      "WhyChoosedescription": "Punctual pickup from anywhere in Pune."
    },
    {
      "WhyChooseheading": "Family-Friendly Travel",
      "WhyChoosedescription": "Spacious vehicles for families and groups."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock booking assistance and trip coordination."
    },
    {
      "WhyChooseheading": "Safe Weekend Travel",
      "WhyChoosedescription": "Secure and reliable weekend getaway travel option."
    }
  ]
}

const faqData = [
  { question: 'How far is Lavasa from Pune?', answer: 'Lavasa is approximately 60 km from Pune and takes around 2 hours depending on traffic and road conditions.' },
  { question: 'Is one-way cab available?', answer: 'Yes, affordable one-way drop service is available.' },
  { question: 'Are SUVs recommended for Lavasa?', answer: 'SUVs are recommended for group travel and added hill-road stability.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are experienced and vehicles are well maintained.' },
  { question: 'Do you provide weekend packages?', answer: 'Yes, weekend round-trip packages available.' },
  { question: 'Can I book online?', answer: 'Yes, instant booking confirmation available.' },
  { question: 'Is pricing transparent?', answer: 'Yes, no hidden charges.' },
  { question: 'Are vehicles sanitized?', answer: 'Yes, sanitized before every trip.' },
  { question: 'Do you provide corporate travel?', answer: 'Yes, corporate and group bookings available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, especially during monsoon and weekends.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akash Mehta',
    feedback: 'Our Lavasa weekend trip with Lotus Cab was smooth and relaxing. Driver handled ghat roads very professionally. Clean vehicle and transparent pricing made the experience excellent.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Pooja Shah',
    feedback: 'Booked family trip to Lavasa. Comfortable SUV, punctual pickup, and safe driving throughout the scenic route. Highly recommended for weekend travel.',
    rating: 5
  }
];














































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lavasa City Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-lavasa-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Lavasa City cabs with affordable one way and round trip taxi services. Book sedan, SUV and luxury cabs for weekend trips, family travel, and comfortable outstation journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-lavasa-city-cabs"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Lavasa City Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Lavasa City cabs with Lotus Cab. Affordable one way & round trip taxi for weekend & family trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Lavasa Cabs, Pune to Lavasa Taxi Service, Pune to Lavasa One Way Cab, Pune to Lavasa Round Trip Taxi, Pune to Lavasa Weekend Trip Cab, Affordable Pune to Lavasa Cab, Luxury Cab Pune to Lavasa, SUV Taxi Pune to Lavasa, Cheap Pune to Lavasa Taxi, Online Cab Booking Pune to Lavasa, Best Pune to Lavasa Cab Service, Pune to Lavasa Family Trip Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolavasacitycab;